import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SECTORS } from '@hrlabs/shared-types';
import { listCollection, type Row } from '../../lib/db';

export function SectorList() {
  const [docs, setDocs] = useState<Map<string, Row>>(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCollection('sectorPages').then((rows) => {
      setDocs(new Map(rows.map((r) => [r.id, r])));
      setLoading(false);
    });
  }, []);

  return (
    <>
      <h3 className="fw-bold mb-1">Sector pages</h3>
      <p className="text-muted small mb-3">
        The five sectors HRLabs recruits for. Names and URLs are fixed in code; you edit each page&apos;s
        content here. Only <strong>published</strong> pages appear in the menu strip, the sectors hub, the
        homepage, the recruitment page and the sitemap.
      </p>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover align-middle">
          <thead>
            <tr>
              <th>Sector</th>
              <th>EN URL</th>
              <th>BG URL</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {SECTORS.map((s) => {
              const status = String(docs.get(s.key)?.status ?? 'not created');
              return (
                <tr key={s.key}>
                  <td>{s.name.en}</td>
                  <td className="small text-muted">/sectors/{s.slug.en}/</td>
                  <td className="small text-muted">/sektori/{s.slug.bg}/</td>
                  <td>
                    <span className={`badge ${status === 'published' ? 'bg-success' : 'bg-secondary'}`}>{status}</span>
                  </td>
                  <td className="text-end">
                    <Link to={`/sectors/${s.key}`} className="btn btn-sm btn-outline-secondary">Edit</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
